export default "__VITE_ASSET__840ce0ef__"